import { Schemas } from '~/api/gen'
import { useModal } from '~/hooks/useModal'
import { CommentOverlay } from '../CommentOverLay'

type Props = {
  coordinate: Schemas.coordinate_large_with_member_shop_brands
}

export const CoordinateComment: React.FC<Props> = ({ coordinate }) => {
  const [Modal, open, close, isOpen] = useModal(200)

  return (
    <>
      {coordinate.is_commentable && (
        <button
          className="mt-[3px] block text-[14px] leading-[1.8] text-blue-500"
          onClick={open}
          type="button"
        >
          {coordinate.aggregate?.comment_count
            ? `コメント${coordinate.aggregate.comment_count}件を表示`
            : `コメントを表示`}
        </button>
      )}
      <Modal
        className={`size-full overflow-y-auto duration-200 ${isOpen ? '' : 'translate-y-5 opacity-0'}`}
        overlayClassName="bg-white/[0.97]"
      >
        <CommentOverlay coordinate={coordinate} close={close} />
      </Modal>
    </>
  )
}
